import React from "react";

// Image \\
import NewsAvatar from "../../assets/images/postImg.svg";

// Style \\
import "../../assets/styles/sections/newsSpaHero.scss";

// Icons \\
import { MdOutlineCalendarToday } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa6";
import { FaRegHeart } from "react-icons/fa6";
import { FaRegUser } from "react-icons/fa";
import { LuEye } from "react-icons/lu";

const NewsSpaHero = () => {
  return (
    <section className="newsSpaHero">
      <div className="newsSpaBg">
        <div className="bg"></div>
        <img src={NewsAvatar} alt="newsAvatar" />
        <div className="container">
          <div className="newsSpaHero_items">
            <div className="text">
              <p>Home / News / Health Care</p>
              <h2>A passion for putting patients first.</h2>
            </div>
            <div className="card_items_info">
              <div className="data">
                <MdOutlineCalendarToday className="calendar" />
                <p>Monday 05, September 2021</p>
              </div>

              <div className="auth">
                <FaRegUser className="user" />
                <p>By Author</p>
              </div>

              <div className="watched">
                <LuEye className="eye" />
                <p>68</p>
              </div>
              <div className="liked">
                <FaRegHeart className="heart" />
                <p>86</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsSpaHero;
